import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import TrunksIp from './components/TrunksIp';
import TrunksAuth from './components/TrunksAuth';
import TrunkOptionCards from './components/TrunkOptionCards';

import { accessLocalStorage, exportUpdateTrunks, exportSelectTrunkById, valuesAnalyze, changeViewForms, readAllTenant, sendReloadAsteriskSystem } from '../../../services';
import { isMasterTenant } from '../../../services/tenantScope';
import { carrierPrefix } from '../../../services/trunkName';

import Loading from '../../Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './TrunksForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPhoneSquareAlt, faPhone, faSave, faArrowLeft, faEdit } from '@fortawesome/free-solid-svg-icons';

const TRUNK_TYPE_OPTIONS = [
  { id: 'type-auth-edit', value: 'Auth', title: 'Autenticado', description: 'Registro na operadora com usuário e senha.' },
  { id: 'type-ip-edit', value: 'IP', title: 'IP', description: 'Operadora identificada pelo endereço IP.' },
];

function TrunksEdit() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({
    "ipLocal": "",
    "trunkNumber": "",
    "authUsername": "",
    "password": "",
    "tenant": "",
    "realNumber": "",
    "provider": "",
    "ipSbcTrunk": "",
    "codec": [],
    "type": "",
    "mode": "bidirecional",
    "qualifyFrequency": 120,
    "regExpiration": 3600,
    "sendRegister": true,
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [saving, setSaving] = useState(false);
  const [updateError, setUpdateError] = useState('');

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    if (!isMasterTenant(idtenant)) fetchTenants = fetchTenants.filter((tenant) => tenant.short_name === idtenant);
    setTenants(fetchTenants);
  }, [history]);

  const validateField = (name, value, currentValues = values) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'trunkNumber') {
      if (!value || value.trim() === '') return false;
      return checkNumber(value);
    }

    if(name === 'password') {
      if (!value || value.trim() === '') return false;
      return value.length > 5;
    }

    if(name === 'mode') {
      return value === 'bidirecional' || value === 'unidirecional';
    }

    if(name === 'realNumber') {
      if (currentValues.mode === 'unidirecional') {
        if (!value || value.trim() === '') return false;
        return value.length >= 10;
      }
      return true;
    }

    if(name === 'provider' || name === 'authUsername') {
      if (!value || value.trim() === '') return false;
      return isTripleChar(value);
    }

    if(name === 'ipSbcTrunk' || name === 'ipLocal') {
      if (!value || value.trim() === '') return false;
      return true;
    }

    if(name === 'tenant') {
      return value && value.trim() !== '';
    }

    if(name === 'type') {
      return value === 'IP' || value === 'Auth';
    }

    if(name === 'codec') {
      return Array.isArray(value) ? value.length > 0 : (value && value.trim() !== '');
    }

    if(name === 'qualifyFrequency') {
      const parsed = Number(value);
      return Number.isInteger(parsed) && parsed >= 0 && parsed <= 86400;
    }

    if(name === 'regExpiration') {
      if (currentValues.sendRegister === false) return true;
      const parsed = Number(value);
      return Number.isInteger(parsed) && parsed >= 60 && parsed <= 7200;
    }

    return true;
  };

  const validateAllFields = useCallback((vals) => {
    const newValidate = {};
    
    newValidate.type = validateField('type', vals.type, vals);
    newValidate.provider = true;
    newValidate.ipSbcTrunk = validateField('ipSbcTrunk', vals.ipSbcTrunk, vals);
    newValidate.tenant = validateField('tenant', vals.tenant, vals);
    newValidate.mode = validateField('mode', vals.mode, vals);
    newValidate.codec = validateField('codec', vals.codec, vals);
    newValidate.qualifyFrequency = validateField('qualifyFrequency', vals.qualifyFrequency, vals);
    newValidate.regExpiration = validateField('regExpiration', vals.regExpiration, vals);
    newValidate.sendRegister = true;
    
    if (vals.type === 'IP') {
      newValidate.trunkNumber = validateField('trunkNumber', vals.trunkNumber, vals);
      newValidate.ipLocal = validateField('ipLocal', vals.ipLocal, vals);
      newValidate.authUsername = true;
      newValidate.password = true;
    } else if (vals.type === 'Auth') {
      newValidate.authUsername = validateField('authUsername', vals.authUsername, vals);
      newValidate.password = validateField('password', vals.password, vals);
      newValidate.trunkNumber = true;
      newValidate.ipLocal = true;
    } else {
      newValidate.trunkNumber = true;
      newValidate.ipLocal = true;
      newValidate.authUsername = true;
      newValidate.password = true;
    }
    
    if (vals.mode === 'unidirecional') {
      newValidate.realNumber = validateField('realNumber', vals.realNumber, vals);
      } else {
      newValidate.realNumber = true;
    }
    
    return newValidate;
  }, []);

  const loadTrunkData = useCallback(async () => {
    if (!itemsSelectedToEdit || itemsSelectedToEdit.length === 0) {
      setLoading(false);
      history.push('/config/tronco/lista');
      return;
    }

    setLoading(true);
    try {
      const result = await exportSelectTrunkById({ elements: itemsSelectedToEdit[0] });
      
      if (result && result.length > 0) {
        const trunk = result[0];
        
        let serverIP = '';
        let localIP = '';
        
        if (trunk.serverIP) {
          if (trunk.serverIP.includes('sip:')) {
            const sipPart = trunk.serverIP.split('sip:')[1];
            if (sipPart.includes('@')) {
              serverIP = sipPart.split('@')[1].split(':')[0];
            } else {
              serverIP = sipPart.split(':')[0];
            }
          } else if (trunk.serverIP.includes(':')) {
            serverIP = trunk.serverIP.split(':')[0];
          } else {
            serverIP = trunk.serverIP;
          }
        }
        
        if (trunk.localIP) {
          if (trunk.localIP.includes('sip:')) {
            const sipPart = trunk.localIP.split('sip:')[1];
            if (sipPart.includes('@')) {
              localIP = sipPart.split('@')[1].split(':')[0];
            } else {
              localIP = sipPart.split(':')[0];
            }
          } else if (trunk.localIP.includes(':')) {
            localIP = trunk.localIP.split(':')[0];
          } else {
            localIP = trunk.localIP;
          }
        }
        
        const trunkType = trunk.nameuser ? 'Auth' : 'IP';
        
        let codecArray = [];
        if (trunk.codec) {
          if (typeof trunk.codec === 'string') {
            codecArray = trunk.codec.split(',').map(c => c.trim()).filter(c => c);
          } else if (Array.isArray(trunk.codec)) {
            codecArray = trunk.codec;
          }
        }
        
        const trunkValues = {
          provider: trunk.name || '',
          ipSbcTrunk: serverIP || '',
          ipLocal: localIP || '',
          trunkNumber: trunk.trunk || '',
          codec: codecArray,
          authUsername: trunk.nameuser || '',
          password: trunk.pass || '',
          type: trunkType,
          tenant: trunk.tenant || '',
          mode: trunk.mode || 'bidirecional',
          realNumber: trunk.real_number || '',
          qualifyFrequency: trunk.qualify_frequency ?? 120,
          regExpiration: trunk.expiration ?? 3600,
          sendRegister: trunk.has_registration !== false,
        };

        setValues(trunkValues);

        setTimeout(() => {
          const initialValidate = validateAllFields(trunkValues);
          setValidate(initialValidate);
        const hasInvalid = Object.values(initialValidate).some(v => v === false);
        setDisable(hasInvalid);
          
          if (trunkType === 'IP') {
            changeVisibityMessages(false, 'trunk-ip-div');
            changeVisibityMessages(true, 'trunk-auth-div');
          } else {
            changeVisibityMessages(false, 'trunk-auth-div');
            changeVisibityMessages(true, 'trunk-ip-div');
          }
          
          if (trunk.real_number) {
            const realNumberFieldIP = document.getElementById('realNumber-field');
            const realNumberFieldAuth = document.getElementById('realNumber-field-auth');
            if (realNumberFieldIP) realNumberFieldIP.style.display = 'flex';
            if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'flex';
          }
          
          changeVisibityMessages(false, 'button-send-form');
        }, 100);
      }
    } catch (error) {
      console.error('Erro ao carregar dados do trunk:', error);
      history.push('/config/tronco/lista');
    } finally {
      setLoading(false);
    }
  }, [itemsSelectedToEdit, history, validateAllFields]);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const isValid = validateField(name, value, values);
    if (name !== 'mode' && name !== 'tenant') {
      changeScreen(isValid, name);
    }
    return isValid;
  };

  const handleChangeCodec = (name, value) => {
    let prevSetValueCodec = values[name];

    if (!values.hasOwnProperty('codec')) prevSetValueCodec = [];
    if (typeof prevSetValueCodec === 'string') prevSetValueCodec = prevSetValueCodec.split(',').map(c => c.trim()).filter(c => c);
    prevSetValueCodec = prevSetValueCodec.includes(value) ? prevSetValueCodec.filter((codec) => codec !== value) : [...prevSetValueCodec, value];
    prevSetValueCodec.toString();

    setValues((prevState) => prevState, values[name] = prevSetValueCodec);
  };

  const handleChangeValues = (item) => {
    const { name, value, type, checked } = item;
    const resolvedValue = type === 'checkbox' && name === 'sendRegister' ? checked : value;

    const itemStatus = handleChangeDataAnalyze(name, resolvedValue);

    if (name === 'codec') {
      handleChangeCodec(name, resolvedValue);
      setTimeout(() => {
        const updatedValues = { ...values, codec: values.codec };
        const newValidate = validateAllFields(updatedValues);
        setValidate(newValidate);
        const hasInvalid = Object.values(newValidate).some(v => v === false);
        setDisable(hasInvalid);
      }, 0);
    } else if (name === 'sendRegister') {
      const turningOn = resolvedValue === true && values.sendRegister === false;
      const emptyExpiration = values.regExpiration === null || values.regExpiration === undefined || values.regExpiration === '';
      const updatedValues = {
        ...values,
        sendRegister: resolvedValue,
        regExpiration: turningOn && emptyExpiration ? 3600 : values.regExpiration,
      };
      setValues(updatedValues);

      setTimeout(() => {
        const fullValidate = validateAllFields(updatedValues);
        setValidate(fullValidate);
        const hasInvalid = Object.values(fullValidate).includes(false);
        setDisable(hasInvalid);
      }, 0);
    } else if (name === 'mode') {
      const updatedValues = { 
        ...values, 
        [name]: value,
        realNumber: value === 'bidirecional' ? '' : values.realNumber
      };
      setValues(updatedValues);
      
      const realNumberFieldIP = document.getElementById('realNumber-field');
      const realNumberFieldAuth = document.getElementById('realNumber-field-auth');
      
      if (value === 'unidirecional') {
        if (realNumberFieldIP) realNumberFieldIP.style.display = 'flex';
        if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'flex';
      } else {
        if (realNumberFieldIP) realNumberFieldIP.style.display = 'none';
        if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'none';
      }
      
      setTimeout(() => {
        const fullValidate = validateAllFields(updatedValues);
        setValidate(fullValidate);
        const hasInvalid = Object.values(fullValidate).includes(false);
        setDisable(hasInvalid);
      }, 0);
    } else {
      const updatedValues = { ...values, [name]: value };
      setValues(updatedValues);
      
      setTimeout(() => {
        const fullValidate = validateAllFields(updatedValues);
        setValidate(fullValidate);
        const hasInvalid = Object.values(fullValidate).includes(false);
        setDisable(hasInvalid);
      }, 0);
    }
    return;
  };

  const typeTrunkSelected = (item) => {
    const { value } = item;
    if (value === 'IP') {
      changeVisibityMessages(false, 'trunk-ip-div');
      changeVisibityMessages(true, 'trunk-auth-div');
      changeVisibityMessages(false, 'button-send-form');
      handleChangeValues(item);
      return;
    }

    changeVisibityMessages(false, 'trunk-auth-div');
    changeVisibityMessages(true, 'trunk-ip-div');
    changeVisibityMessages(false, 'button-send-form');
    handleChangeValues(item);
    return;
  };

  const hideUpdateForm = () => {
    toggleIsHidden('#trunk-all-form');
    changeVisibityMessages(true, 'trunk-ip-div');
    changeVisibityMessages(true, 'trunk-auth-div');
    changeVisibityMessages(true, 'button-send-form');
  };

  const showUpdateError = (message) => {
    setUpdateError(message);
    changeVisibityMessages(false, 'nosuccess-update-trunks');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const sendDataTrunkUpdate = async () => {
    const dataToSend = {
      trunkName: itemsSelectedToEdit[0],
      ...values,
      codec: Array.isArray(values.codec) ? values.codec.join(',') : values.codec
    };

    setSaving(true);

    try {
      const fetchTrunks = await exportUpdateTrunks(dataToSend);

      if (fetchTrunks && fetchTrunks.success) {
        await sendReloadAsteriskSystem({ command: 'asterisk' }).catch(() => null);

        changeVisibityMessages(true, 'nosuccess-update-trunks');
        hideUpdateForm();
        changeVisibityMessages(false, 'success-update-trunks');

        window.scrollTo({ top: 0, behavior: 'smooth' });

        setTimeout(() => {
          history.push('/config/tronco/lista');
        }, 3000);
        return;
      }

      if (fetchTrunks?.code === 'NAME_CHANGE_BLOCKED') {
        showUpdateError(fetchTrunks.error || 'O nome do tronco não pode ser alterado.');
        return;
      }

      showUpdateError(fetchTrunks?.error || 'Não foi possível atualizar o tronco.');
    } catch (error) {
      showUpdateError('Não foi possível atualizar o tronco. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  useEffect(() => {
    if (tenants.length === 0) return;
    
    if (itemsSelectedToEdit && itemsSelectedToEdit.length > 0) {
      loadTrunkData();
    } else {
      const timeoutId = setTimeout(() => {
        if (!itemsSelectedToEdit || itemsSelectedToEdit.length === 0) {
          history.push('/config/tronco/lista');
        }
      }, 1000);
      
      return () => clearTimeout(timeoutId);
    }
  }, [itemsSelectedToEdit, tenants, history, loadTrunkData]);

  if (loading) {
    return <Loading />;
  }

  const identity = {
    locked: true,
    lockedCarrierLabel: carrierPrefix(values.provider),
    trunkName: values.provider,
  };

  return (
    <div className="trunks-form-container">
      <div className="trunks-form-header">
        <div className="trunks-form-title-wrapper">
          <svg className="trunks-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
    <div>
            <h1 className="trunks-form-title">Editar Tronco</h1>
            <p className="trunks-form-subtitle">Atualize as configurações do tronco SIP</p>
          </div>
        </div>
        <Link to="/config/tronco/lista" className="btn-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar
        </Link>
      </div>

      <div className="alerts-section">
        <div id="nosuccess-update-trunks" name="nosuccess-update-trunks" className="alert-message alert-danger is-hidden">
          <div className="alert-header">
            <span>Erro!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#nosuccess-update-trunks')}>×</button>
        </div>
          <div className="alert-body">
            {updateError || 'Não foi possível atualizar o tronco. Verifique os dados e tente novamente.'}
        </div>
        </div>

        <div id="success-update-trunks" name="success-update-trunks" className="alert-message alert-success is-hidden">
          <div className="alert-header">
            <span>Sucesso!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-update-trunks')}>×</button>
            </div>
          <div className="alert-body">
            Tronco atualizado com <strong>sucesso</strong>!
          </div>
        </div>
      </div>

      <div id="trunk-all-form" className="trunk-type-card">
        <p className="trunk-type-title">Tipo de Tronco</p>
        <TrunkOptionCards name="type" options={TRUNK_TYPE_OPTIONS} selectedValue={values.type} onSelect={typeTrunkSelected} />
        <p name="type-invalid-data" className="form-error is-hidden">Selecione o tipo de tronco!</p>
      </div>

      <div name="trunk-ip-div" className="is-hidden">
        <TrunksIp changeValues={handleChangeValues} tenants={tenants} values={values} identity={identity} />
      </div>

      <div name="trunk-auth-div" className="is-hidden">
        <TrunksAuth changeValues={handleChangeValues} tenants={tenants} values={values} identity={identity} />
      </div>

      <div name="button-send-form" className="is-hidden">
        <div className="form-actions trunk-form-actions-end">
          <Link to="/config/tronco/lista" className="btn-cancel">
                  <FontAwesomeIcon icon={faArrowLeft} />
            Cancelar
          </Link>
          <button className="btn-submit" type="submit" disabled={disable || saving} onClick={() => sendDataTrunkUpdate()}>
                  <FontAwesomeIcon icon={faSave} />
                <span>{saving ? 'Salvando...' : 'Salvar Alterações'}</span>
              </button>
        </div>
      </div>
    </div>
  );
}

export default TrunksEdit;
